import script from "./ShopCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopCollection.vue?vue&type=script&setup=true&lang=js"

import "./ShopCollection.vue?vue&type=style&index=0&id=3b873c7b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b873c7b"]])

export default __exports__